import {ListComponentsHoteleria} from '../../components/components'
import {FC, useState} from 'react'
import {useHoteleria} from '../../../../hooks/useHoteleria'
import {ModuleErrorColumn, ModuleModel} from '../../features/modules/models'
import {yupResolver} from '@hookform/resolvers/yup'
import {newModuleSchema} from '../../../../util/validationHoteleria'
import {FormProvider, useForm} from 'react-hook-form'
import ContainerWrapper from '../../../central/pages/componentes/Container'
import {Panel, PanelGroup} from 'react-resizable-panels'
import {SnackbarProvider, enqueueSnackbar} from 'notistack'
import {ResizeHandle} from '../../components/Layout/Container/ResizeHandle/ResizeHandle'
import ActionsContent from '../components/Actions'
import {
  createModuleService,
  deleteModuleService,
  editModuleService,
} from '../../services/module.service'
import {TabModel} from '../../../../models'
import Swal from 'sweetalert2'
import {getSnackBar, getSnackBarToast} from '../../../../util/snackBar'
import {ModalErrorTable} from '../../features/modules/components/Modal/ModalErrorTable'

const renderPanelContent = (key: string | undefined) => {
  let component = <></>
  if (key) {
    component = ListComponentsHoteleria[key]
  }
  return component
}

const ModulePageWrapper: FC = () => {
  const {currentTabItem, changeCurrentTabItem} = useHoteleria()
  const [showModalError, setShowModalError] = useState<boolean>(false)
  const [dataError, setDataError] = useState<ModuleErrorColumn[]>([])
  const [messageError, setMessageError] = useState<string>('')
  const [loading, setLoading] = useState(false)
  const methods = useForm<ModuleModel>({
    resolver: yupResolver(newModuleSchema),
  })

  const handleDelete = async () => {
    // await new Promise((resolve) => setTimeout(resolve, 2000))
    // debugger
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminar no podrás revertir esta acción',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        setLoading(true)
        let id = [{Id: currentTabItem.idToDelete}]
        changeCurrentTabItem({...currentTabItem, loadingTable: true, deleted: false})

        const data = await deleteModuleService(id)
        if (!data.data.error) {
          setLoading(false)

          const obj: TabModel = {
            ...currentTabItem,
            idToDelete: '',
            loadingTable: false,
            deleted: true,
          }
          changeCurrentTabItem(obj)
          getSnackBarToast('Se eliminó con éxito', 'success')
        } else {
          setLoading(false)
          changeCurrentTabItem({...currentTabItem, loadingTable: false, deleted: false})
          getSnackBarToast(data.data.message, 'error')
        }
        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  const onSubmit = async (data: ModuleModel) => {
    try {
      setLoading(true)
      let num1 = data.Campoadicionalnum1 ? Number(data.Campoadicionalnum1) : 0
      data.Campoadicionalnum1 = num1
      let num2 = data.Campoadicionalnum2 ? Number(data.Campoadicionalnum2) : 0
      data.Campoadicionalnum2 = num2
      let num3 = data.Campoadicionalnum3 ? Number(data.Campoadicionalnum3) : 0
      data.Campoadicionalnum3 = num3
      let nroHabitaciones = data.NroHabitaciones ? Number(data.NroHabitaciones) : 0
      data.NroHabitaciones = nroHabitaciones
      let nroPisos = Number(data.NroPisos)
      data.NroPisos = nroPisos
      let prioridad = data.PrioridadAsignacion ? Number(data.PrioridadAsignacion) : 0
      data.PrioridadAsignacion = prioridad
      if (currentTabItem.idToEdit) {
        changeCurrentTabItem({...currentTabItem, loadingTable: true, updated: false})
        const response = await editModuleService(data)
        if (!response.data.error) {
          setLoading(false)
          getSnackBarToast('Se actualizó el registro correctamente', 'success')
          const obj: TabModel = {
            ...currentTabItem,
            showPanel: false,
            idToEdit: '',
            content: {
              ...currentTabItem.content,
              detailPanel: '',
            },
            loadingTable: false,
            updated: true,
          }
          changeCurrentTabItem(obj)
        } else {
          setLoading(false)
          changeCurrentTabItem({...currentTabItem, loadingTable: false, updated: false})
          if (response.data.data && response.data.data.length > 0) {
            await setDataError(response.data.data)
            await setMessageError(response.data.message)
            await setShowModalError(true)
          } else {
            getSnackBarToast(response.data.message, 'error')
          }
        }
      } else {
        const response = await createModuleService(data)
        if (!response.data.error) {
          setLoading(false)
          getSnackBarToast('Se creó con éxito', 'success')
          const obj: TabModel = {
            ...currentTabItem,
            showPanel: false,
            idToEdit: '',
            content: {
              headerPanel: 'table-modules',
            },
          }
          changeCurrentTabItem(obj)
        } else {
          let message = response?.data?.message?.toString() || ''
          getSnackBarToast(message, 'error')
        }
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <ActionsContent
          deleteClick={handleDelete}
          loading={loading}
          textComponentBack='table-modules'
          textComponentGo='form-module'
        />
        <ContainerWrapper>
          <PanelGroup autoSaveId='example' direction='vertical'>
            <Panel
              collapsible={true}
              order={1}
              key={`panel-hoteleria-header-${currentTabItem.title}`}
              id={`panel-hoteleria-header-${currentTabItem.title}`}
              className={'panel__box'}
            >
              {renderPanelContent(currentTabItem.content.headerPanel)}
            </Panel>
            {currentTabItem.showPanel && (
              <>
                <ResizeHandle />
                <Panel
                  className={'panel__box'}
                  collapsible={true}
                  defaultSize={50}
                  order={2}
                  key={`panel-hoteleria-detail-${currentTabItem.title}`}
                  id={`panel-hoteleria-detail-${currentTabItem.title}`}
                >
                  {renderPanelContent(currentTabItem.content.detailPanel)}
                </Panel>
              </>
            )}
          </PanelGroup>
          {showModalError && (
            <ModalErrorTable
              data={dataError}
              show={showModalError}
              setShow={setShowModalError}
              message={messageError}
            />
          )}
        </ContainerWrapper>
      </form>
      <SnackbarProvider />
    </FormProvider>
  )
}

export {ModulePageWrapper}
